import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './map.module.scss';
import PhoneIcon from '../../assets/icon_phone.svg';
import EmailIcon from '../../assets/email-icon.svg';
import Instagram from '../../assets/instagram_icon.svg';
import Facebook from '../../assets/facebook_icon.svg';
import NavPoint from '../../assets/nav_point.svg';

const Map = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <header id="contact">
        <h2 className={styles.map__title}>{t('mapTitle')}</h2>
      </header>
      <div className={styles.map}>
        <div className={styles.map__description}>
          <div className={styles.description}>
            <div>
              <p className={styles.description__paragraph}>{t('mapServiceTitle')}</p>
              <a className={styles.description__phone} href="tel:+48-666-528-797">
                +48 666 528 797
              </a>
              <p className={styles.description__paragraphNormal}>{t('mapServiceHours')}</p>
            </div>
            <a className={styles.description__phone} href="tel:+48-666-528-797">
              <img className={styles.map__phoneIcon} src={PhoneIcon} alt="Ikona telefonu" />
            </a>
          </div>
          <div className={styles.description}>
            <div>
              <p className={styles.description__paragraphMargin}>{t('mapSalonTitle')}</p>
              <a className={styles.description__phone} href="tel:+48-601-515-930">
                +48 601 515 930
              </a>
              <p className={styles.description__paragraphNormal}>{t('mapSalonHours')}</p>
            </div>
            <a className={styles.description__phone} href="tel:+48-601-515-930">
              <img className={styles.map__phoneIcon} src={PhoneIcon} alt="Ikona telefonu" />
            </a>
          </div>
          <div className={styles.description}>
            <div>
              <p className={styles.description__paragraphNormalMargin}>{t('mapEmail')}</p>
              <p className={styles.description__paragraphDecoration}>
                <a className={styles.description__phoneMail} href="mailto:kontakt@bergregions.pl">
                  kontakt@bergregions.pl
                </a>
              </p>
            </div>
            <a className={styles.description__phoneMail} href="mailto:kontakt@bergregions.pl">
              <div className={styles.map__email}>
                <img className={styles.map__emailIcon} src={EmailIcon} alt="Ikona email" />
              </div>
            </a>
          </div>
          <div>
            <div>
              <p className={styles.description__paragraphMargin}>Social media:</p>
            </div>
            <div className={styles.description__mediaBox}>
              <a
                className={styles.description__link}
                href="/"
                target="_blank"
                rel="noreferrer"
                title="Link do Instagram"
              >
                <img className={styles.description__socialIcon} src={Instagram} alt="Ikona email" />
              </a>
              <a
                className={styles.description__link}
                href="/"
                target="_blank"
                rel="noreferrer"
                title="Link do Facebook"
              >
                <img className={styles.description__socialIcon} src={Facebook} alt="Ikona email" />
              </a>
            </div>
            <div
              className={styles.description__qr}
              style={{
                background: `url('${process.env.PUBLIC_URL}/img/qr-code-berg.svg')`,
                backgroundSize: 'cover',
              }}
            />
          </div>
        </div>
        <div className={styles.map__map}>
          <div className={styles.nav}>
            <div>
              <p style={{ fontWeight: 'bold' }}>Berg Regions Sp. z o.o.</p>
              <p>ul. św. Benedykta 6/16, 30- 536 Kraków</p>
            </div>
            <img className={styles.nav__point} src={NavPoint} alt="Punkt nawigacyjny" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Map;
